// lib/consentScripts.ts

let googleLoaded = false;

export function loadGoogleAds() {
  if (typeof window === "undefined") return;
  if (googleLoaded) return;
  googleLoaded = true;

  window.dataLayer = window.dataLayer || [];

  window.gtag = function (...args: any[]) {
    window.dataLayer.push(args);
  };

  window.gtag("js", new Date());

  const script = document.createElement("script");
  script.src =
    "https://www.googletagmanager.com/gtag/js?id=AW-17122483794";
  script.async = true;

  script.onload = () => {
    window.gtag("config", "AW-17122483794");
  };

  document.head.appendChild(script);
}